import script from "./BarcodeHandlerMixin.vue?vue&type=script&lang=ts"
export * from "./BarcodeHandlerMixin.vue?vue&type=script&lang=ts"

export default script